// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c6977d5d","212":"8b286520","285":"a1d449fd","582":"52def7a8","605":"a11e6b5f","676":"3e4c2d95","827":"20d57bd8","863":"d2d6725d"}[chunkId] + ".chunk.css";
};